import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {getFormattedMessage} from 'features/services/utils/language-helper';

import './style.scss';

import {Icon} from 'components/atoms/Media/Icon';
import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';

interface Props {
    onClick: () => void;
    isOpen: boolean;
    controls?: string;
}

export const ExpandButton: React.FunctionComponent<Props> = ({onClick, isOpen, controls}) => {
    return (
        <Button
            onClick={onClick}
            buttonColor={ButtonColor.LIGHT} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={ButtonType.DEFAULT}
            iconBtn 
            icon={<Icon name={isOpen ? 'minus' : 'plus'} />}
            ariaExpanded={isOpen}
            ariaControls={controls}
            ariaLabel={getFormattedMessage(isOpen ? "jm.components.ExpandButton.less" : "jm.components.ExpandButton.more")}
            className='expand-button'
        >
            <FormattedMessage id={isOpen ? "jm.components.ExpandButton.less" : "jm.components.ExpandButton.more"}/>
        </Button>
    )
};
